import { defineComponent as _defineComponent } from 'vue'
import CreatePaymentMethodForm from "@/components/forms/CreatePaymentMethodForm.vue";
import VModal from "@/components/vModal.vue";

type ModalProps = {
  showModal: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'vCreatePaymentMethodModal',
  props: {
    showModal: { type: Boolean }
  },
  emits: ['onPaymentMethodCreated', 'cancel'],
  setup(__props: any, { emit }) {




return { __sfc: true,emit, CreatePaymentMethodForm, VModal }
}

})